import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { ISku, ISkuInput } from "@/interfaces/sku.interface";
import skuService from "@/services/sku.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateSkuProps = {
  formData: ISkuInput;
} & RequestsProps;

export type UseCreateSkuReturn = {
  create: (props: CreateSkuProps) => Promise<ISku>;
} & UseLoadingReturn;

const useCreateSku = (): UseCreateSkuReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<ISkuInput>({
    operation: (formData) => skuService.create(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateSku;
